app.service("DiagnosisAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		var service = {
			isProcessing: false,

			// Shared with dashboard list + diagnosis modal: pending (AI) last, then newest first, then alphabetical
			sortDiagnosisItems: function (items) {
				items.sort((a, b) => {
					const isPendingA = a.is_human_verified === 'PENDING' ? 1 : 0;
					const isPendingB = b.is_human_verified === 'PENDING' ? 1 : 0;
					if (isPendingA !== isPendingB) return isPendingA - isPendingB;

					const dateA = a.date_diagnosis_onset ? new Date(a.date_diagnosis_onset).getTime() : 0;
					const dateB = b.date_diagnosis_onset ? new Date(b.date_diagnosis_onset).getTime() : 0;
					if (dateA !== dateB) return dateB - dateA;

					const termA = (a.snomed_concept && a.snomed_concept.pt && a.snomed_concept.pt.term) ? a.snomed_concept.pt.term.toLowerCase() : "";
					const termB = (b.snomed_concept && b.snomed_concept.pt && b.snomed_concept.pt.term) ? b.snomed_concept.pt.term.toLowerCase() : "";
					if (termA < termB) return -1;
					if (termA > termB) return 1;
					return 0;
				});
				return items;
			},

			searchDiagnosis: function (term, isOcular, isNonCataract) {
				// Free text typed by the user: "&", "#" or "+" in it would otherwise break the query string.
				const encodedTerm = encodeURIComponent(term);
				return $http({
					method: "GET",
					url: ENV.API + (isNonCataract ? `/api/diagnosis?term=${encodedTerm}&isNonCataract=true` : `/api/diagnosis?term=${encodedTerm}&isOcular=${isOcular}`),
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
            saveDiagnosis: function (patientId, diagnosisArray) {
                return $http({
					method: "POST",
					url: ENV.API + `/api/diagnosis/patient/${patientId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
                    data: diagnosisArray
				}); 
            },
            inactivateDiagnosis: function (patientId, diagnosisId) {
                return $http({
					method: "PATCH",
					url: ENV.API + `/api/diagnosis/patient/${patientId}/diagnosis/${diagnosisId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
                    data: {
                        status: "INACTIVE",
                        inactivation_reason: null
                    }
				}); 

			},
			verifyDiagnosis: function (patientId, diagnosisId, is_human_verified) {
				return $http({
					method: "PATCH",
					url: ENV.API + `/api/diagnosis/patient/${patientId}/diagnosis/${diagnosisId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: {
						is_human_verified: is_human_verified
					}
				});

			},
			// Edit user-editable fields on an existing diagnosis. `fields` is a plain object of
			// snake_case API fields (e.g. { date_diagnosis_onset: "2023/06/14" }); only the fields
			// sent are changed server-side, so new editable fields need no new method here.
			updateDiagnosis: function (patientId, diagnosisId, fields) {
				return $http({
					method: "PATCH",
					url: ENV.API + `/api/diagnosis/patient/${patientId}/diagnosis/${diagnosisId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: fields
				});
			},
            getDiagnosis: function(patientId){
                return $http({
					method: "GET",
					url: ENV.API + `/api/diagnosis/patient/${patientId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});

            }
		};

		return service;
	},
]);
